export enum AuthenticatedUserMenuActionEnum {
  /** Opens Account hub (/account/profile). */
  Account = 'account',
  Divider = 'divider',
  /** Profile submenu: two-factor (TOTP) and passkeys. */
  Security = 'security',
  Totp = 'totp',
  /** Opens passkey registration and management for the signed-in user. */
  Passkeys = 'passkeys',
  AppDebugDrawer = 'app-debug-drawer',
  /** Profile submenu: active sessions and folder unlock sessions. */
  SessionsMenu = 'sessions-menu',
  Sessions = 'sessions',
  FileSessions = 'file-sessions',
  PublicLinks = 'public-links',
  StopImpersonation = 'stop-impersonation',
  ImpersonateUser = 'impersonate-user',
  SignOut = 'sign-out',
}
